import { Box, Modal } from "@mui/material";
import React, { Suspense, useEffect, useRef, useState } from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { ModalStyleFeedback } from "../../../../common/components/ModalStyle";
import {
  getDiDashboardDiet,
  getDiDashboardIntakeOutput,
  getDiDashboardLabParameters,
  getDiDashboardLines,
  getDiDashboardScores,
  getDiDashboardToDoList,
  getDiDashboardTreatmentAndInfusion,
  getDiDashboardVentilator,
  getDiDashboardVitals,
} from "../../../services/diPatientServices/DIPatientService";
import CommonDivider from "../../../../common/components/divider/CommonDivider";
import { FaCamera } from "react-icons/fa";
import videoFile from "./MICUMonitor.mp4"

const VitalsGraph = React.lazy(() => import("./VitalsGraph"));
const LabList = React.lazy(() => import("./LabList"));
const LinesList = React.lazy(() => import("./LinesList"));
const Scores = React.lazy(() => import("./Scores"));
const Ventilator = React.lazy(() => import("./Ventilator"));
const InputOutput = React.lazy(() => import("./InputOutput"));
const DiatList = React.lazy(() => import("./DiatList"));
const Treatment = React.lazy(() => import("./Treatment"));
const ToDoList = React.lazy(() => import("./ToDoList"));

function ICUDIDashboardModal({
  open,
  handleClose,
  setSelectedRow,
  selectedRow,
}) {
  const [vitalsGraphData, setVitalsGraphData] = useState(null);
  const [labListData, setLabListData] = useState(null);
  const [linesListData, setLinesListData] = useState(null);
  const [scoreData, setScoreData] = useState(null);
  const [ventilationData, setVentilationData] = useState(null);
  const [inputOutputData, setInputOutputData] = useState(null);
  const [dietData, setDietData] = useState(null);
  const [treatmentData, setTreatmentData] = useState(null);
  const [toDoListData, setToDoListData] = useState(null);
  const [openVideo, setOpenVideo] = React.useState(false);

  const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "90%",
    overflowY: "auto",
    // bgcolor: "black",
    // border: "3px solid red",
    borderRadius: "5px",
    boxShadow: 50,
    zIndex: 999,
  };

  const handleCloseVideo = () => {
    if (openVideo === true) {
      setOpenVideo(false);
    }
  };

  const hasFetchedData = useRef(false);

  const fetchData = () => {
    const admissionId = selectedRow?.admissionid;
    if (!admissionId) return;
    const apiCalls = [
      getDiDashboardVitals(admissionId),
      getDiDashboardLabParameters(admissionId),
      getDiDashboardLines(admissionId),
      getDiDashboardScores(admissionId),
      getDiDashboardVentilator(admissionId),
      getDiDashboardIntakeOutput(admissionId),
      getDiDashboardDiet(admissionId),
      getDiDashboardTreatmentAndInfusion(admissionId),
      getDiDashboardToDoList(admissionId),
    ];
    Promise.all(
      apiCalls.map((call) =>
        call
          .then((response) => response.data.body.result)
          .catch((error) => ({ error })),
      ),
    ).then(
      ([
        vitals,
        lab,
        lines,
        scores,
        ventilation,
        inputOutput,
        diet,
        treatment,
        toDoList,
      ]) => {
        setVitalsGraphData(vitals);
        setLabListData(lab);
        setLinesListData(lines);
        setScoreData(scores);
        setVentilationData(ventilation);
        setInputOutputData(inputOutput);
        setDietData(diet);
        setTreatmentData(treatment);
        setToDoListData(toDoList);
      },
    );
  };

  useEffect(() => {
    if (selectedRow !== null) {
      if (hasFetchedData.current) return;
      hasFetchedData.current = true;
      fetchData();
    }
  }, [selectedRow]);

  //   {
  //     "Bed No": "1012 D",
  //     "Patient Name": "KAMINI RAJESH ARORA",
  //     "ICU Days": 0,
  //     "Ventilation": false,
  //     "Oxygen": false,
  //     "DI": null,
  //     "QSOFA": 1,
  //     "GCS": 6,
  //     "MEWS": 8,
  //     "Apache Score": null,
  //     "AdmissionId": 1071144
  // }
  console.log(
    "MonitorSelectedRow",
    open,
    handleClose,
    setSelectedRow,
    selectedRow,
  );

  const handleVideo = () => {
    setOpenVideo(true);
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={ModalStyleFeedback}
        className="w-[95%] h-[95%] rounded-lg overflow-y-auto"
      >
        <CancelPresentationIconButton
          onClick={() => {
            handleClose();
            setSelectedRow(null);
          }}
        />
        <h1 className="2xl:text-2xl text-xl text-center py-1 font-semibold">
          Deterioration Index
        </h1>
        <div className="grid grid-cols-3 gap-2 pb-2">
          <div className="grid grid-cols-3 col-span-2 gap-2 p-2 bg-gray-100 rounded font-semibold whitespace-nowrap text-xs 2xl:text-sm">
            <h5 className="flex space-x-2">
              <span>Patient Name</span>
              <span>: {selectedRow?.patientname}</span>
            </h5>
            <h5 className="flex space-x-[14px] 2xl:space-x-4">
              <span>UHID</span>
              <span>:{selectedRow?.MRNo}</span>
            </h5>
            <h5 className="flex space-x-2">
              <span>Age / Gender</span>
              <span>: {selectedRow?.AgeGender}</span>
            </h5>
            <h5 className="flex space-x-[17px] 2xl:space-x-[18.5px]">
              <span>Department</span>
              <span>: {selectedRow?.Department}</span>
            </h5>
            <h5 className="flex space-x-1">
              <span>Doctor</span>
              <span>: {selectedRow?.DoctorName}</span>
            </h5>
          </div>
          <div className="p-2 bg-[#DAEBFF] rounded text-customBlue text-xs 2xl:text-sm flex space-x-2">
            <h5 className="font-semibold">Diagnosis :</h5>
            <h5 className="font-semibold">
              {selectedRow?.Diagnosis &&
              JSON.parse(selectedRow.Diagnosis).length > 0
                ? JSON.parse(selectedRow.Diagnosis).map((list, index, arr) => (
                    <>
                      {list.Diagnosis}
                      {index < arr.length - 1 && ", "}
                    </>
                  ))
                : ""}
            </h5>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 h-auto w-full">
          <div className="bg-black text-white rounded-lg w-full px-2 pb-2">
            <div className="whitespace-nowrap">
              <div className="flex justify-between items-center p-2 text-[14px]">
                <p className="font-semibold text-lg">
                  {selectedRow.patientname}
                </p>
                <div>
                  <button
                    className="text-white"
                    type="button"
                    onClick={handleVideo}
                  >
                    <FaCamera className="text-[24px]" />
                  </button>
                </div>
                <p className="font-semibold">
                  Bed No : {selectedRow.bedno}
                  {/* , {selectedRow.name} */}
                </p>

                {/* <div className="flex gap-2 items-center">
              <div>
                {criticalValues?.includes(i) ? <BlinkingDotWithRing /> : ""}
              </div>
              <p
                className={`${
                  i === 3 || i === 4 || i === 5
                    ? `bg-[#f2b35a]`
                    : i === 6 || i === 7 || i === 8
                    ? `bg-[#368505]`
                    : `bg-[#ED0A0A] `
                } px-3 py-1 rounded font-medium flex items-center space-x-1`}
              >
                <span>
                  {criticalValues?.includes(i) ? <WarningAmberIcon /> : ""}
                </span>
                <span>{`${
                  i === 3 || i === 4 || i === 5
                    ? `Moderate`
                    : i === 6 || i === 7 || i === 8
                    ? `Normal`
                    : `Crirical`
                }`}</span>
              </p>
            </div> */}
              </div>
              <CommonDivider color="#7A7A7A" />
              <div className="grid grid-cols-3 items-center h-full">
                <div className="text-[#00FC00] text-[13px] w-full border-b border-r border-gray-700 px-2 pb-3">
                  <p className="font-semibold">Heart Rate (bpm)</p>
                  <h4 className="text-[25px]">{selectedRow.heartrate}</h4>
                </div>
                <div className="font-semibold text-[13px] border-b border-r border-gray-700 pl-[13px] w-full text-[#00FCFF] pb-3">
                  <p>SpO2 (%)</p>
                  <h4 className="text-[25px]">{selectedRow.spo2val}</h4>
                </div>
                <div className="text-[#FF3100] font-semibold w-full border-b border-gray-700 pb-3 pl-3">
                  <p className="text-[13px]">NIBP (mmHg)</p>
                  <h4 className="text-[25px]">{selectedRow.bp}</h4>
                </div>
                <div className="font-semibold text-white w-full border-b border-r border-gray-700 pl-3">
                  <p className="text-[13px]">MEAN (mmHg)</p>
                  <h4 className="text-[20px]">{selectedRow.mean}</h4>
                  {/* <h4 className="text-[14px]">mmHg (93)</h4> */}
                </div>
                <div className="text-[#1695DF] font-semibold border-b border-r border-gray-700 pl-3">
                  <h4 className="text-[13px]">RESP (bpm)</h4>
                  <h4 className="text-[20px]">{selectedRow.respiration}</h4>
                </div>
                <div className="text-[#1695DF] font-semibold border-b border-gray-700 pl-3 ">
                  <h4 className="text-[13px]">VPC (Per/Min)</h4>
                  <h4 className="text-[20px]">{selectedRow.vpc}</h4>
                </div>
              </div>
              <div className="grid grid-cols-5  items-center h-full">
                <div className="text-[#F9A200] font-semibold  pl-3 ">
                  <h4 className="text-[13px] mt-2">TEMP (°F)</h4>
                  <h4 className="text-lg">{selectedRow.temperature}</h4>
                </div>
                <div className="text-[#FB5959] font-semibold border-l border-gray-700 pl-3 ">
                  <h4 className="text-[13px] mt-2">qSOFA</h4>
                  <h4 className="text-lg">{selectedRow.qsofa}</h4>
                </div>
                <div className="text-[#EE8936] font-semibold border-l border-gray-700 pl-3">
                  <h4 className="text-[13px] mt-2">MEWS</h4>
                  <h4 className="text-lg">{selectedRow.mews}</h4>
                </div>
                <div className="text-[#5CD75E] font-semibold border-l border-gray-700 w-full pl-3.5">
                  <h4 className="pr-5 text-[13px] mt-2">GCS</h4>
                  <h4 className="pr-5 text-lg">{selectedRow.gcs}</h4>
                </div>
                <div className="text-[#00FC00] font-semibold border-l border-gray-700 w-full pl-2">
                  <h4 className="text-[13px] mt-2">APACHE</h4>
                  <h4 className="text-lg">{selectedRow.apache}</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[100%]">
            <Suspense
              fallback={
                <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                  <p> Loading Vitals Graph...</p>
                </div>
              }
            >
              <VitalsGraph vitalsGraphData={vitalsGraphData} />
            </Suspense>
          </div>
        </div>
        <div className="grid grid-cols-4 h-auto gap-2 w-full whitespace-nowrap">
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Lab List...</p>
              </div>
            }
          >
            <LabList labListData={labListData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Lines List...</p>
              </div>
            }
          >
            <LinesList linesListData={linesListData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Scores...</p>
              </div>
            }
          >
            <Scores scoreData={scoreData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Ventilator...</p>
              </div>
            }
          >
            <Ventilator ventilationData={ventilationData} />
          </Suspense>
        </div>
        <div className="grid grid-cols-4 gap-2 py-2 h-auto">
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Input/Output...</p>
              </div>
            }
          >
            <InputOutput inputOutputData={inputOutputData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Diet List...</p>
              </div>
            }
          >
            <DiatList dietData={dietData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading Treatment...</p>
              </div>
            }
          >
            <Treatment treatmentData={treatmentData} />
          </Suspense>
          <Suspense
            fallback={
              <div className="text-center text-sm py-10 2xl:py-20 text-gray-600">
                <p> Loading To-Do List...</p>
              </div>
            }
          >
            <ToDoList toDoListData={toDoListData} />
          </Suspense>
        </div>

        <Modal
          BackdropProps={{
            sx: {
              backdropFilter: "blur(5px)",
              WebkitBackdropFilter: "blur(7px)",
              backgroundColor: "rgba(0,0,0,0.55)", // dim outside
            },
          }}
          onClose={handleCloseVideo}
          open={openVideo}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={ModalStyle} className="bg-black">
            <div className="">
              <video src={videoFile} autoPlay width={"100%"} height={"100%"} />
            </div>
          </Box>
        </Modal>
      </Box>
    </Modal>
  );
}

export default ICUDIDashboardModal;
